import api from './api';

// Client for the generic AiDocument store — saved, manually editable AI output.

export interface AiDocument {
  id: string;
  feature: string;
  type?: string | null;
  title: string;
  content: string;
  data?: unknown;
  provider?: string | null;
  model?: string | null;
  isEdited: boolean;
  editedAt?: string | null;
  /** Eingaben der Erzeugung (icpId, personaId, offerId, ...) -- Herkunft. */
  inputParams?: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

class AiDocumentService {
  // List the current user's saved documents, optionally filtered by feature.
  async list(feature?: string): Promise<AiDocument[]> {
    const response = await api.get('/ai-documents', {
      params: feature ? { feature } : undefined,
    });
    return response.data;
  }

  async get(id: string): Promise<AiDocument> {
    const response = await api.get(`/ai-documents/${id}`);
    return response.data;
  }

  async update(id: string, data: { content?: string; title?: string }): Promise<AiDocument> {
    const response = await api.put(`/ai-documents/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/ai-documents/${id}`);
  }
}

const aiDocumentService = new AiDocumentService();
export default aiDocumentService;
